import React, { useContext } from "react";
import {
  Typography,
  Card,
  CardContent,
  Grid,
  Divider,
  InputBase,
} from "@material-ui/core";

import { makeStyles } from "@material-ui/core/styles";
import { LangContext } from "../../Context/Langcontext";

const useStyles = makeStyles((theme) => ({
  mainText: {
    color: "#E16733",
    fontSize: "1.2rem",
    fontWeight: 700,
  },
  secondText: {
    color: "#595A5A",
    fontSize: "1rem",
    fontWeight: 200,
    marginTop: "1rem",
  },
  cardstyle: {
    width: "100%",
    borderRadius: 8,
    boxShadow: "1px 1px 5px 0px rgba(191,192,191,1)",
    WebkitBoxShadow: "1px 1px 5px 0px rgba(191,192,191,1)",
    MozBoxShadow: "1px 1px 5px 0px rgba(191,192,191,1)",
    backgroundColor: "#f1f1f1",
    marginTop: "1rem",
    "& .MuiCardContent-root:last-child": {
      padding: "10px 20px 10px 10px",
    },
    "& .MuiCardContent-root": {
      padding: "12px",
    },
  },
  cardapi: {
    width: "100%",
    borderRadius: 8,
    backgroundColor: "#f1f1f1",
    boxShadow: "unset",
    marginTop: "1rem",
    "& .MuiCardContent-root:last-child": {
      padding: "10px 20px 10px 10px",
    },
    "& .MuiCardContent-root": {
      padding: "12px",
    },
  },
  divider: {
    marginTop: "1rem",
    marginBottom: "1rem",
  },
  lastitem: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
  },
  cardhead: {
    letterSpacing: 1,
    fontWeight: 700,
    color: "#595a5a",
  },
  cardmid: { fontWeight: 200, color: "#595a5a" },
  inputStyle: {
    fontWeight: 200,
    fontSize: "1rem",
    color: "#595A5A",
  },
  collapseStyle: {
    marginTop: "0.5rem",
    marginBottom: "0.5rem",
    borderRadius: 8,
    boxShadow: "unset",
    backgroundColor: "#F8F8F8",
  },
  gridunderline: {
    borderBottom: "1px solid rgba(0, 0, 0, 0.12)",
    paddingBottom: "0.5rem",
  },
  gridunder: {
    paddingBottom: "0.5rem",
  },
  codeText: {
    color: "#595A5A",
    fontSize: "1rem",
    fontWeight: 700,
    marginTop: "1rem",
  },
}));
const Introduction = () => {
  const classes = useStyles();
  const langContext = useContext(LangContext);
  const lang = langContext.lang.data;

  const code = [
    { title: 200, detail: "OK" },
    { title: 400, detail: "Bad Request" },
    { title: 401, detail: "Unauthorized" },
    { title: 403, detail: "Forbidden" },
    {
      title: 404,
      detail: "Not Found",
    },
    {
      title: 407,
      detail: "Proxy Authentication Required",
    },
    {
      title: 502,
      detail: "Bad Gateway",
    },
    {
      title: 504,
      detail: "Gateway Timeout",
    },
  ];

  const howto = [
    { title: lang.Howto1 },
    { title: lang.Howto2 },
    { title: lang.Howto3 },
    { title: lang.Howto4 },
    { title: lang.Howto5 },
  ];

  return (
    <div style={{ margin: "2rem 2rem 1rem 2rem" }}>
      <Typography className={classes.mainText} id="intro">
        Introduction to MEA API
      </Typography>
      <Typography className={classes.secondText}>
        {lang.SubtitlesIntroduction}
      </Typography>

      <Divider className={classes.divider} />
      <Typography id="accesstoken" className={classes.mainText}>
        {lang.Accesstoken}
      </Typography>

      <Card className={classes.cardapi}>
        <CardContent className={classes.cardcontent}>
          <InputBase
            type={"text"}
            value={`${process.env.REACT_APP_API_URL}/${process.env.REACT_APP_API_V}/{endpoint}?api_key={your_api_key}`}
            disabled
            fullWidth
            style={{ minWidth: 100 }}
            inputProps={{
              className: classes.inputStyle,
            }}
          />
        </CardContent>
      </Card>

      <Typography className={classes.secondText}>
        API Key คือรหัสผ่านสำหรับการอนุญาตเข้าใช้งาน API ทั้งในส่วนของ Data
        Service และ Map Service
      </Typography>
      <Divider className={classes.divider} />

      <Typography
        className={classes.mainText}
        id="response"
        style={{ marginTop: "1rem" }}
      >
        {lang.ResponseMessages}
      </Typography>

      <Grid container>
        <Grid item md={3} sm={6} xs={6} className={classes.gridunderline}>
          <Typography className={classes.codeText}>{lang.Code}</Typography>
        </Grid>
        <Grid item md={6} sm={6} xs={6} className={classes.gridunderline}>
          <Typography className={classes.codeText}>
            {lang.Description}
          </Typography>
        </Grid>
        <Grid item md={3}></Grid>
        {code.map((rs, index) => {
          return (
            <Grid container key={`${index}_${rs.title}`}>
              <Grid
                item
                md={3}
                sm={6}
                xs={6}
                className={
                  index === code.length - 1
                    ? classes.gridunder
                    : classes.gridunderline
                }
              >
                <Typography className={classes.secondText}>
                  {rs.title}
                </Typography>
              </Grid>
              <Grid
                item
                md={6}
                sm={6}
                xs={6}
                className={
                  index === code.length - 1
                    ? classes.gridunder
                    : classes.gridunderline
                }
              >
                <Typography className={classes.secondText}>
                  {rs.detail}
                </Typography>
              </Grid>
              <Grid item md={3}></Grid>
            </Grid>
          );
        })}
      </Grid>

      <Divider className={classes.divider} />
      <Typography
        className={classes.mainText}
        id="howto"
        style={{ marginTop: "1rem" }}
      >
        {lang.Howtouse}
      </Typography>
      <Grid container>
        {howto.map((rs, index) => {
          return (
            <Grid item md={12} sm={12} xs={12} key={`${index}_${rs.title}`}>
              <Typography className={classes.secondText}>{rs.title}</Typography>
            </Grid>
          );
        })}
      </Grid>
      <Divider className={classes.divider} />
    </div>
  );
};

export default Introduction;
